




import { Component, Vue } from 'vue-property-decorator'
import templateCom from './templateCom.vue'

@Component({
  name: 'roleSetting',
  components: {
    templateCom
  }
})
export default class extends Vue {
  dataObj = {
    url: '/blackcat/role/findall',
    addUrl: '/blackcat/role/save',
    delUrl: '/blackcat/role/delete',
    type: 'manageRole',
    title: '角色管理',
    pathname: 'manageRoleSetting',
    tbHead1: '角色名'
  }
}
